import { FC, ReactElement } from 'react'

import { ASSETS } from '../../../constants'
import { useI18n } from '../../../hooks'
import Parallax from '../../parallax'

import './index.css'

const FacultyBanner: FC = (): ReactElement => {
  const imageData = {
    src: `${ASSETS}/banners/faculty-page/faculty_page_desktop.jpg`,
    alt: 'faculty-banner',
  }
  const classNames = {
    banner: `faculty-page-header`,
  }
  const { t } = useI18n()
  return (
    <Parallax classNames={classNames} imgData={imageData} bgPosition="center" isStatic>
      <div className="faculty-banner-title-container">
        <h1 className="faculty-banner-title vendor-top-banner-title">{t('Faculty_softwareSavingsForFaculty').toUpperCase()}</h1>
        <p className="faculty-banner-content banner-subtitle">
          {t('Common_saveUpTo')} <span className="heavy">90%</span> {t('Faculty_saveUpToText')}
          <span style={{ display: 'block' }}>{t('Faculty_youMayBeEligibleText')}</span>
        </p>

        <a href="#faculty-school" className="faculty-banner-button light">
          {t('Faculty_findMySchoolToGetStarted')}
        </a>
      </div>
    </Parallax>
  )
}

export default FacultyBanner
